import CostSettings from './CostSettings';
import type { CostVehicle } from './costModel';
import type { CaptureWorkState } from './useCostCapture';

/** Reuse the vehicle editor in place so a captured expense never leaves memory. */
export default function CaptureVehicleEditor({ onCreated, onClose, onWorkStateChange }: {
  onCreated: (vehicle: CostVehicle) => void; onClose: () => void;
  onWorkStateChange: (state: CaptureWorkState) => void;
}) {
  return <CostSettings canWrite canApprove={false} openAddOnMount captureOnly
    onCreated={onCreated} onCancel={onClose} onWorkStateChange={onWorkStateChange} />;
}
